var exports = {
  "V": "dismissalCommentTextarea__FhRffy",
};

module.exports = exports;
